import { FC } from 'react';
import { BiFileBlank } from 'react-icons/bi';
import { StateMessage, StateMessageProps } from './state-message';

export const EmptyState: FC<StateMessageProps> = ({
  icon = BiFileBlank,
  ...props
}) => {
  return <StateMessage icon={icon} data-testid="empty-state" {...props} />;
};
